import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAdmin, isManager } from '../service/authService';

export default function ReportRoute(props) {
   const checkReport = isAdmin() || isManager();

   if (localStorage.getItem('username')) {
      if (checkReport) {
         return <Route {...props} />;
      } else {
         return <Redirect to='/RequestHistory' />;
      }
   } else {
      return <Redirect to='/login' />;
   }
}
